import { TileLayer, useMap } from 'react-leaflet';
import { useEffect } from 'react';

/** Esri World Boundaries and Places — reference labels on aerial basemap. */
const ESRI_REFERENCE_TILES =
  'https://server.arcgisonline.com/ArcGIS/rest/services/Reference/World_Boundaries_and_Places/MapServer/tile/{z}/{y}/{x}';

export default function AerialReferenceOverlay() {
  const map = useMap();

  useEffect(() => {
    map.getPane('overlayPane')?.classList.add('aerial-reference-overlay');
  }, [map]);

  return (
    <TileLayer
      url={ESRI_REFERENCE_TILES}
      opacity={0.85}
      zIndex={450}
      attribution="Labels &copy; Esri"
    />
  );
}
